<template lang="pug">
component.k-object-base( :is='tag' :class='{ inline }' )
  .header
    h2.title
      | {{ inline ? '' : title }}
    transition( name='fade' appear )
      k-pager(
        v-if='pages > 1'
        v-bind=`{ pages, perPage }`
        :value='page'
        @input='gotoPage'
        show-end
      )
    w-btn-icon( @click.prevent='refresh' )
      i-reload
    transition( name='fade' appear )
      d-loading(
        v-if='loading || !thisObjects'
        spinner-size='var(--s-3q)'
        spinner-thickness='1px'
      )
  transition( name='fade' mode='out-in' appear )
    .body( v-if='thisObjects && !thisObjects.length' key='empty' )
      .empty
        | There are no items
    .body( v-else-if='inline' :key='page' v-bar )
      .inner
        component(
          :is='itemBlock'
          v-for='object in thisObjects'
          v-bind='{ model, object, icons, selecting }'
          :key =`( object.error_data && object.error_data.ach_access_denied &&
            object.error_data.ach_access_denied.redirect ) || object.id`
          :selected='!!selected[ object.id ]'
          :actions='preprocessActions( itemActions, { model, item: object })'
          @refresh='refresh'
          @select='selectItem'
        )
    .body( v-else :key='page' )
      component(
        :is='itemBlock'
        v-for='object in thisObjects'
        v-bind='{ model, object, icons, selecting }'
        :key =`( object.error_data && object.error_data.ach_access_denied &&
          object.error_data.ach_access_denied.redirect ) || object.id`
        :selected='!!selected[ object.id ]'
          :actions='preprocessActions( itemActions, { model, item: object })'
        @refresh='refresh'
        @select='selectItem'
      )
  .foooter
    k-actions-icons(
      v-if='groupActions && groupActions.length && selecting'
      v-bind='{ model, icons }'
      :items='Object.values( selected )'
      :actions='groupActions'
      @refresh='refresh'
    )
    k-actions( 
      v-if='!inline'
      type='icon-text'
      v-bind=`{ model, actions, icons }`
    )
</template>

<script lang="js">
import { mapActions } from 'vuex'
import DLoading from '@/displays/d-loading'
import IReload from 'icons/Reload'
import KActions from '@/blocks/k-actions'
import KActionsIcons from '@/blocks/k-actions-icons'
import KItem from '@/blocks/k-item'
import KPager from '@/blocks/k-pager'
import WBtnIcon from '@/widgets/w-btn-icon'
import { preprocessActions } from '@/lib/util'

export default {
  name: 'BaseObjectsBlock',
  mixins: [],
  components: {
    DLoading,
    IReload,
    KActions,
    KActionsIcons,
    KItem,
    KPager,
    WBtnIcon,
  },
  props: {
    tag: {
      type: String,
      default: 'section'
    },
    title: String,
    scroll: Boolean,
    model: {
      type: Object,
      default: () => ({})
    },
    collection: String,
    objects: Array,
    filter: {
      type: Object,
      default: () => ({})
    },
    actions: {
      type: Array,
      default: () => []
    },
    itemActions: {
      type: Array,
      default: () => []
    },
    groupActions: {
      type: Array,
      default: () => []
    },
    icons: {
      type: Object,
      default: () => ({})
    },
    inline: Boolean,
  },
  data() {
    return {
      modelObjects: null,
      loading: false,
      page: 1,
      pages: 1,
      perPage: 10,
      total: 0,
      selected: {}
    }
  },
  created() {
    if (( !this.objects || !this.objects.length ) &&
        ( this.model || this.collection )) {
      this.getObjects()
    }
  },
  mounted() {},
  methods: {
    ...mapActions([ 'getModelsPage' ]),
    preprocessActions,
    async getObjects( page ) {
      const { perPage: per_page, filter, model } = this
      if ( !page ) {
        page = this.page
      }
      this.loading = true
      const { items, total, pages } = await this.getModelsPage({
        model: model.collection || model.model,
        page,
        per_page,
        ...filter
      })
      this.loading = false
      this.modelObjects = items
      this.page = page
      this.pages = pages
      this.total = total
    },
    gotoPage( page ) {
      this.getObjects( page )
    },
    refresh() {
      this.getObjects()
      this.selected = {}
    },
    selectItem( item ) {
      this.$set( this.selected, item.id, this.selected[ item.id ] ? null : item )
    },
  },
  computed: {
    thisObjects() {
      return this.modelObjects || this.objects
    },
    itemBlock() {
      return ( this.model && this.model.components &&
               this.model.components.item &&
               this.model.components.item() ) || KItem
    },
    selecting() {
      return !!Object.values( this.selected ).find( x => x )
    },
  }
}
</script>

<style lang="scss">
.k-object-base {
  > .header {
    text-align: left;
    display: flex;
    padding-right: var(--s-xl);
    > .title {
      flex: 1;
      margin: 0;
      margin-right: var(--s-sm);
    }
    .d-loading {
      position: absolute;
      top: 0;
      right: var(--s-sm);
      width: auto;
      height: auto;
      /* --c-loader: rgba(0,0,0,0.72); */
      --c-loader: rgba(128,128,128,0.72);
      isolation: isolate;
      .spinner-frame {
        mix-blend-mode: difference;
      }
      /* .spinner-inner { */
      /*   background: rgba(128,128,128,0.2); */
      /*   --w-border: 0; */
      /* } */
    }
  }
  &.inline {
    margin-right: var(--s-base);
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-right: 0 !important;
    > .header {
      margin-right: var(--pad-section, var(--s-base));
    }
    > .body {
      position: relative;
      > .inner {
        padding-right: var(--pad-section, var(--s-base));
      }
    }
    .inner {
      max-height: 100%;
    }
  }
}
</style>
